// Task #984 — Stripe Connect gate for host-accept (full-payment markets).
//
// Mirror of `artifacts/api-server/src/lib/stripe-connect-gate.ts`. Kept
// side-effect-free so the booking detail page, the bookings list, and the
// API handler all decide "is this host blocked from accepting?" with one
// shared rule. See the api-server copy for the full rationale.

export type ApprovePaymentType = "full" | "partial" | string | null | undefined;

export interface ConnectApproveFacts {
  paymentType: ApprovePaymentType;
  hasAccount: boolean;
  payoutsEnabled: boolean | null | undefined;
  chargesEnabled: boolean | null | undefined;
}

export function isFullPaymentApproveType(paymentType: ApprovePaymentType): boolean {
  const pt = (paymentType || "full").toString().toLowerCase();
  return pt !== "partial";
}

export function requiresStripeConnectForApprove(facts: ConnectApproveFacts): boolean {
  if (!isFullPaymentApproveType(facts.paymentType)) return false;
  if (!facts.hasAccount) return true;
  if (!facts.payoutsEnabled) return true;
  if (!facts.chargesEnabled) return true;
  return false;
}

export const STRIPE_CONNECT_REQUIRED_CODE = "stripe_connect_required";
